import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

export interface IGetHouses {
  page: 1;
  page_size: 10000;
  format: 'create_order_reservation';
  type: 'house_status';
  physical_status: number;
  house_type_id?: number;
  group_id?: number;
  begin: string;
  end: string;
}

interface ICheckStatus {
  house_ids: string;
  begin: string;
  end: string;
}

const GET_GROUP_LIST_API = '/api/house_group/group_list';
const GET_HOUSE_TYPE_LIST_API = '/api/house_type/all';
const GET_HOUSES_LIST_API = '/api/reservation/house_list';
const GET_HOUSES_RESERVATION_STATUS_API = '/api/reservation/houses_reservation_status';

@Injectable()
export class SearchDateAndHouseService {

  constructor(
    private http: HttpClient
  ) { }

  /** 获取全部房源分组 */
  getGroupList() {
    return this.http.get(GET_GROUP_LIST_API) as Observable<IHttpResponse>;
  }

  /** 获取房型列表 */
  getHouseTypeList() {
    return this.http.get(
      GET_HOUSE_TYPE_LIST_API
    ) as Observable<IHttpResponse>;
  }

  /** 创建订单时房间列表 */
  getHousesList(params: IGetHouses) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('format', `${params.format}`)
      .append('type', `${params.type}`)
      .append('physical_status', `${params.physical_status}`)
      .append('house_type_id', `${params.house_type_id}`)
      .append('group_id', `${params.group_id}`)
      .append('begin', `${params.begin}`)
      .append('end', `${params.end}`);
    return this.http.get(GET_HOUSES_LIST_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }

  /** 房间入住单与可订状态 */
  getHousesReservationStatus(params: ICheckStatus) {
    const query = new HttpParams()
      .append('house_ids', `${params.house_ids}`)
      .append('begin', `${params.begin}`)
      .append('end', `${params.end}`);
    return this.http.get(GET_HOUSES_RESERVATION_STATUS_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }
}
